__turbopack_context__.v({
  "accordionBody": "FAQ-module__V8_xEa__accordionBody",
  "accordionCollapse": "FAQ-module__V8_xEa__accordionCollapse",
  "accordionHeader": "FAQ-module__V8_xEa__accordionHeader",
  "accordionItem": "FAQ-module__V8_xEa__accordionItem",
  "accordionWrapper": "FAQ-module__V8_xEa__accordionWrapper",
  "faq": "FAQ-module__V8_xEa__faq",
  "icon": "FAQ-module__V8_xEa__icon",
  "open": "FAQ-module__V8_xEa__open",
  "question": "FAQ-module__V8_xEa__question",
});
